exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (max-width: 1200px) {\n  .ui.button.button-reduce-spacing {\n    padding-left: 0.2em;\n    padding-right: 0.2em;\n    font-size: 0.9rem;\n  }\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?-autoprefixer!./~/postcss-loader!./~/less-loader!./src/styles/containers/project/unitLayouts/project.less
// module id = 2836
// module chunks = 0